var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "History" }, [
    _c("div", { staticClass: "History__icon" }, [
      _c(
        "a",
        {
          staticClass: "icon-btn",
          attrs: { href: "#" },
          on: { click: _vm.openSidebar },
        },
        [_c("FontAwesomeIcon", { attrs: { icon: "history" } })],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.open
      ? _c("div", { staticClass: "History__sidebar" }, [
          _c("div", { staticClass: "History__sidebar__close" }, [
            _c("h2", [_vm._v("History")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "icon-btn",
                attrs: { href: "#" },
                on: { click: _vm.closeSidebar },
              },
              [_c("FontAwesomeIcon", { attrs: { icon: "times" } })],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "History__sidebar__entries" },
            _vm._l(_vm.animes, function (anime) {
              return _c("HistoryEntry", {
                key: anime.id.value,
                attrs: { anime: anime },
                on: { "click-entry": _vm.emitShowAnime },
              })
            }),
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }